import React from 'react';
import { useNavigate, Link } from 'react-router-dom';

const PageFooter = () => {
    const navigate = useNavigate();

    return (
        <footer className="border-t border-purple-200/50 py-12" style={{ backgroundColor: 'rgba(240, 253, 244, 0.5)' }} data-testid="page-footer">
            <div className="max-w-7xl mx-auto px-4 md:px-8">
                <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                    <div className="flex items-center space-x-2">
                        <img src="/sampler-logo.png" alt="Sampler" className="h-8 w-auto" />
                        <span className="text-lg font-bold" style={{ fontFamily: 'Unbounded, sans-serif' }}>Sampler</span>
                    </div>
                    <nav className="flex items-center gap-6 text-sm text-slate-500" style={{ fontFamily: 'Barlow, sans-serif' }}>
                        <button onClick={() => navigate('/for-talent')} className="hover:text-[#8B5CF6] transition-colors" data-testid="footer-for-talent">For Talent</button>
                        <button onClick={() => navigate('/for-employers')} className="hover:text-[#8B5CF6] transition-colors" data-testid="footer-for-employers">For Employers</button>
                        <button onClick={() => navigate('/login')} className="hover:text-[#8B5CF6] transition-colors" data-testid="footer-login">Log In</button>
                    </nav>
                    <p className="text-sm text-slate-400">&copy; 2026 Sampler. All rights reserved.</p>
                </div>
                {/* Legal links — always visible regardless of auth or beta state */}
                <div className="mt-6 pt-6 border-t border-purple-100 flex justify-center gap-6 text-xs text-slate-400" style={{ fontFamily: 'Barlow, sans-serif' }}>
                    <Link to="/legal/privacy-policy" className="hover:text-[#8B5CF6] transition-colors" data-testid="footer-privacy-policy">Privacy Policy</Link>
                    <Link to="/legal/candidate-terms" className="hover:text-[#8B5CF6] transition-colors" data-testid="footer-candidate-terms">Candidate Terms of Use</Link>
                    <Link to="/legal/cookie-policy" className="hover:text-[#8B5CF6] transition-colors" data-testid="footer-cookie-policy">Cookie Policy</Link>
                    <Link to="/legal/complaints-disputes" className="hover:text-[#8B5CF6] transition-colors" data-testid="footer-complaints-disputes">Complaints &amp; Disputes</Link>
                </div>
            </div>
        </footer>
    );
};

export default PageFooter;
